/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'admin-panel': {
    width: 12,
    height: 12,
    viewBox: '0 0 12 12',
    data: '<path pid="0" d="M0 .857C0 .384.384 0 .857 0H3.43c.473 0 .857.384.857.857V3.43a.857.857 0 01-.857.857H.857A.857.857 0 010 3.429V.857zM0 8.571c0-.473.384-.857.857-.857H3.43c.473 0 .857.384.857.857v2.572a.857.857 0 01-.857.857H.857A.857.857 0 010 11.143V8.57zM8.571 0a.857.857 0 00-.857.857V3.43c0 .473.384.857.857.857h2.572A.857.857 0 0012 3.429V.857A.857.857 0 0011.143 0H8.57zM7.714 8.571c0-.473.384-.857.857-.857h2.572c.473 0 .857.384.857.857v2.572a.857.857 0 01-.857.857H8.57a.857.857 0 01-.857-.857V8.57z" _fill="#0071B3"/>'
  }
})
